/**
 * 组件使用场景：驳回审批
 * API使用 ->
 * API:import { showRejectReason } from '@/shared/utils';
 * showRejectReason({
 *     id:'' //主键id =>required
 *     callback:()=>void // 驳回成功回调函数
 * })
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, Modal, notification } from 'antd';
import { Provider, connect } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
});
class RejectReason extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
    }
    cancel() {
        dispatch.approve.SHOW_REJECT({
            isShow: false,
            id: null,
            callback: null,
        });
    }
    afterClose() {
        this.props.form.resetFields();
    }
    ok() {
        this.props.form.validateFields()
            .then((formData) => {
            dispatch.approve.unAgreeApprove(formData.rejectReason);
        })
            .catch(() => {
            notification.error({
                message: '提交失败',
                description: <div>请填写相关带<span style={{ color: 'red' }}>*</span>必填</div>,
            });
        });
    }
    render() {
        const { showReject } = this.props.approve;
        const { getFieldDecorator } = this.props.form;
        return (<Modal visible={showReject} onCancel={this.cancel} onOk={this.ok} afterClose={this.afterClose} closable={false}>
        <Form>
          <Form.Item label={'请填写驳回理由'} help={'限50字'}>
            {getFieldDecorator('rejectReason', {
            rules: [
                {
                    required: true,
                    message: '请输入驳回理由',
                },
                {
                    max: 50,
                    message: '限50字',
                },
            ],
        })(<Input.TextArea placeholder="请输入驳回理由（必填）" autoSize={{
            minRows: 4,
            maxRows: 4,
        }}/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
}
const RejectReasonComponent = connect(mapStateToProps)(Form.create({})(RejectReason));
export default RejectReasonComponent;
/**
 * API
 * */
let componentRef = '';
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    div.className = 'souche-reject-reason';
    document.body.appendChild(div);
    const refFn = (ref) => {
        componentRef = ref;
    };
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(RejectReasonComponent, {
        ref: refFn,
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showRejectReason({ id, callback }) {
    if (!componentRef) {
        createAbortiveAuction();
    }
    dispatch.approve.SHOW_REJECT({
        isShow: true,
        id,
        callback,
    });
}
